import _ from "lodash";

import { createFuncDef } from "../../../services/utils/index.js";

export default setFieldValues => [
  createFuncDef((id, data) => {
    setFieldValues({
      _id: id,
      email: _.isNil(data.coach) ? "" : data.coach.email,
      planId: data.planId,
      isEditing: data.isEditing,
    });
  }),
];
